import { type Page, RowConfig } from '../../types';
import { CSC_REPORTING_PERIOD_DEFAULT } from './shared_variables';

const details: Page[] = [
  {
    pageType: 'question',
    title: 'Points of contact',
    name: 'points-of-contact',
    hidePageTitle: true,
    description: '',
    hideContinueButton: true,
    navigateToSummaryOnComplete: true,
    questions: [
      {
        questionType: 'reportPeriod',
        title: 'Period of Report',
        name: 'report-period',
        defaultValue: CSC_REPORTING_PERIOD_DEFAULT,
        readOnly: true,
        rules: {
          required: true,
        },
      },
      {
        name: 'department',
        questionType: 'select',
        title: 'Organisation',
        hintOption: 'Please Select',
        options: [
          'Advisory, Conciliation and Arbitration Service',
          'Animal and Plant Health Agency',
          'Cabinet Office',
          'Centre for Environment, Fisheries and Aquaculture Science',
          'Charity Commission',
          'Companies House',
          'Competition and Markets Authority',
          'Crown Office and Procurator Fiscal Service',
          'Crown Prosecution Service',
          'Defence Equipment and Support',
          'Department for Business & Trade',
          'Department for Culture, Media & Sport',
          'Department for Education',
          'Department for Energy, Security and Net Zero',
          'Department for Environment, Food & Rural Affairs',
          'Department for Science, Innovation & Technology',
          'Department for Transport',
          'Department for Work and Pensions',
          'Department of Health and Social Care',
          'Estyn',
          'FCDO Services',
          'Food Standards Agency',
          'Foreign, Commonwealth and Development Office',
          'Forestry Commission',
          "Government Actuary's Department",
          'Government Commercial Agency',
          'Government Commercial Organisation',
          'Government Legal Department',
          'Health and Safety Executive',
          'HM Land Registry',
          'HM Revenue & Customs',
          'HM Treasury',
          'Home Office',
          'Intellectual Property Office',
          'Medicines and Healthcare products Regulatory Agency',
          'Met Office',
          'Ministry of Defence',
          'Ministry of Housing, Communities and Local Government',
          'Ministry of Justice',
          'National Crime Agency',
          'National Savings and Investments',
          'Northern Ireland Office',
          'Ofgem',
          'Ofqual',
          'Ofsted',
          'Office for National Statistics',
          'Office of Rail and Road',
          'Ofwat',
          'Planning Inspectorate',
          'QEII Centre',
          'Registers of Scotland',
          'Rural Payments Agency',
          'Scottish Courts and Tribunals Service',
          'Scottish Prison Service',
          'Serious Fraud Office',
          'The Insolvency Service',
          'The National Archives',
          'The Scottish Government',
          'UK Debt Management Office',
          'UK Export Finance',
          'UK Health Security Agency',
          'UK Hydrographic Office',
          'UK Space Agency',
          'Veterinary Medicines Directorate',
          'Welsh Government',
          'Welsh Revenue Authority',
          'Wilton Park Executive Agency',
        ],
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'HR Director details',
        name: 'hr-director-name',
        // detailsHeading: 'More information',
        detailsContent: 'HR Director (or equilent) name',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'HR Director email',
        name: 'hr-director-email',
        // detailsHeading: 'More information',
        detailsContent: 'HR Director (or equilent) email address',
        rules: {
          required: true,
          email: true,
        },
      },
      {
        questionType: 'inset',
        title: 'Key contacts for recruitment',
        insetContent:
          'These contacts will be used to send out correspondence. They will also' +
          ' be sent the quarterly data return. Please double check for spelling mistakes<br><br>' +
          'If you have any additional people, please let us know.',
        name: 'poc-inset',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'First contact named',
        name: 'contact-name-1',
        detailsContent: 'First contact name',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'First contact email address',
        name: 'contact-email-1',
        detailsContent: 'First contact email address',
        rules: {
          required: true,
          email: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'Second contact name',
        name: 'contact-name-2',
        // detailsHeading: 'More information',
        detailsContent: 'Key contact 2 name',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'Second contact email address',
        name: 'contact-email-2',
        // detailsHeading: 'More information',
        detailsContent: 'Key contact 2 email address',
        rules: {
          required: true,
          email: true,
        },
      },
      {
        questionType: 'inset',
        title: 'Contact details',
        insetContent: 'These will be used to send a confirmation email of your return submission.',
        name: 'contact-details-inset',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'First name',
        name: 'contact-details-first-name',
        detailsContent: 'First name',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'Second name',
        name: 'contact-details-second-name',
        detailsContent: 'Second name',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'Email address',
        name: 'contact-details-email',
        detailsContent: 'Email address',
        rules: {
          required: true,
          email: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'Phone number',
        name: 'contact-details-phone-number',
        detailsContent: 'Phone number',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'This return has been completed by',
        name: 'contact-details-completed-by',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textInput',
        title: 'This return has been signed off by (HR Director or Equivalent)',
        name: 'contact-details-signed-off-by',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textarea',
        title:
          "Please provide below a list of all arm's length bodies from which data has been included in this return",
        detailsContent: 'If no arm length bodies are included in your return, please enter N/a',
        name: 'contact-details-alb-list',
        rules: {
          required: true,
        },
      },
    ],
  },
];
export default details;
